import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ILBMXMegaMenu } from '../lbmx-mega-menu.interface';

@Component({
  selector: 'lbmx-mega-menu',
  templateUrl: './lbmx-mega-menu.component.html',
})
export class LBMXMegaMenuComponent {
  @Input() public model: ILBMXMegaMenu[];
  private isMobile = false;

  constructor(private route: ActivatedRoute) {}

  @Input('isMobile') set mobileBooleanSetter(isMobile: boolean) {
    if (isMobile) {
      this.isMobile = isMobile;
    }
  }

  public handleActiveLink(routerLink: string): string {
    const snapshot: any = this.route.snapshot;
    if (snapshot._routerState.url.includes(routerLink)) {
      return 'selected';
    } else {
      return '';
    }
  }

  public handleEvents(event: Event, command: any) {
    this.runCommand(command);
    this.stop(event);
  }

  public runCommand(command: any) {
    if (command) {
      command();
    }
  }

  public stop(event: Event) {
    event.stopPropagation();
  }

  // UGLY FUNCTION
  public getIconOrLabel(element: any, gettingLabel: boolean) {
    if (gettingLabel) {
      if (this.isMobile) {
        return element.label;
      } else if (element.icon) {
        return '';
      } else {
        return element.label;
      }
    } else {
      if (this.isMobile) {
        return '';
      } else {
        if (element.icon) {
          return element.icon;
        } else {
          return '';
        }
      }
    }
  }
}
